import { PlanTypesEnum } from '@ctct/domain-layer';
import type { ComparisonTableFeature, ComparisonTableGroup } from '@ctct/payflow-ui';

import contentValueFocusedMWeb from './contentValueFocusedMWeb';
import type { ContentStrategy } from '../ContentStrategy';

const idToTypeMap = {
  '1': PlanTypesEnum.Bronze,
  '2': PlanTypesEnum.Silver,
  '3': PlanTypesEnum.Gold,
};

/**
 * Content strategy for mobile web variant.
 *
 * Displays SMS Marketing without country-specific messaging.
 * Group name: "SMS Marketing" (no country suffix in headers or tooltips).
 * Uses "Add-on" pricing format instead of dollar amounts.
 * Visibility is controlled at runtime by PlanComparisonTableService based on endpoint eligibility.
 *
 * See specs/sms-international.md for full details.
 */
export class ValueFocusedMWebContentStrategy implements ContentStrategy {
  getInitialGroups(): ComparisonTableGroup[] {
    return contentValueFocusedMWeb.groups.map((g) => ({
      ...g,
      features: g.features.map((f) => ({
        ...f,
        parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
      })),
    }));
  }

  getInitialPlans() {
    return contentValueFocusedMWeb.headers.plans;
  }

  getStaticTableContent(): ComparisonTableFeature[] {
    return contentValueFocusedMWeb.marketingData[0].features.slice(1).map((f) => ({
      ...f,
      parameters: f.parameters.map((p) => ({ ...p, id: idToTypeMap[p.id] })),
    }));
  }
}
